import { enqueueSnackbar } from "notistack";
import {
  G2_OPERATOR_SIGNUP_REQUEST,
  OPERATOR_FILE_UPLOAD_FAILURE,
  OPERATOR_FILE_UPLOAD_REQUEST,
  OPERATOR_FILE_UPLOAD_SUCCESS,
  OPERATOR_SIGN_UP_FAILURE,
  OPERATOR_SIGN_UP_REQUEST,
  OPERATOR_SIGN_UP_SUCCESS,
  UPDATE_OPERATOR_ACCOUNT_DETAILS,
} from "../constants";
import {
  getGatePinLocationRequest,
  getGatePinRequest,
  postAuthenticationRequest,
  postAuthenticationRequestWithoutAccessToken,
  postAuthenticationRequestWithoutAuth,
  putAuthenticationRequest,
} from "../../../services/apiManager/apiRequests";
import apiConfig from "../../../services/apiManager/apiConfig";
import SnackbarConfig from "../../../utils/snackbarConfig";
import { substituteUrlParams } from "../../../services/apiManager/helper";

export const updateOperatorAccountDetails = (data) => ({
  type: UPDATE_OPERATOR_ACCOUNT_DETAILS,
  payload: data,
});

export const updateOperatorAddressDetails = (data) => ({
  type: UPDATE_OPERATOR_ACCOUNT_DETAILS,
  payload: data,
});

export const operatorSignUpRequest =
  (params, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: OPERATOR_SIGN_UP_REQUEST,
        payload: { isLoading: true },
      });
      const response = await postAuthenticationRequestWithoutAccessToken(
        apiConfig.operatorSignUp,
        params,
      );
      if (response?.user) {
        enqueueSnackbar("Driver successfully created", {
          variant: "success",
          autoHideDuration: 3000,
          action: SnackbarConfig,
        });
        dispatch({
          type: OPERATOR_SIGN_UP_SUCCESS,
          payload: response,
        });
        callback(response);
      } else {
        dispatch({
          type: OPERATOR_SIGN_UP_FAILURE,
          payload: { isLoading: false },
        });
        callback({});
      }
      dispatch({
        type: OPERATOR_SIGN_UP_FAILURE,
        payload: { isLoading: false },
      });
    } catch (error) {
      callback({});
      if (error?.response?.data?.error_description) {
        enqueueSnackbar("Failed to sign up operator", {
          variant: "error",
          autoHideDuration: 3000,
          action: SnackbarConfig,
        });
      }
      dispatch({
        type: OPERATOR_SIGN_UP_FAILURE,
        payload: { isLoading: false },
      });
    }
  };

export const operatorFileUploadRequest =
  (uploadedImage, userId, isLoggedIn, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: OPERATOR_FILE_UPLOAD_REQUEST,
        payload: { isLoading: true },
      });
      const formData = new FormData();
      if (uploadedImage) {
        formData.append(
          "preValidatedMetadata",
          JSON.stringify({
            visibility: "PRIVATE",
            lifespan: "PERMANENT",
          }),
        );
        formData.append(
          "fileInfos",
          JSON.stringify([
            {
              name: "file0",
              mediaType:
                uploadedImage.type === "application/pdf"
                  ? "PDF"
                  : uploadedImage.type,
            },
          ]),
        );
        formData.append("uploadType", "DOCUMENT");
        formData.append("entityType", "SAFE_TRUCK_PARKING");
        formData.append("file0", uploadedImage);
        formData.append("userId", userId);
      }
      let response;
      if (isLoggedIn)
        response = await postAuthenticationRequest(
          apiConfig.operatorFileUploadLoggedIn,
          formData,
          null,
          null,
          "multipart/form-data",
        );
      else
        response = await postAuthenticationRequestWithoutAuth(
          apiConfig.operatorFileUpload,
          formData,
          null,
          null,
          "multipart/form-data",
        );
      if (response?.userId || response?.data) {
        enqueueSnackbar("Image uploaded successfully", {
          variant: "success",
          autoHideDuration: 3000,
          action: SnackbarConfig,
        });
        dispatch({
          type: OPERATOR_FILE_UPLOAD_SUCCESS,
          payload: response,
        });
        callback(response);
      } else {
        dispatch({
          type: OPERATOR_FILE_UPLOAD_FAILURE,
          payload: { isLoading: false },
        });
        callback({});
      }
      dispatch({
        type: OPERATOR_FILE_UPLOAD_FAILURE,
        payload: { isLoading: false },
      });
    } catch (error) {
      callback({});
      if (error?.response?.data?.message) {
        enqueueSnackbar("Failed to upload image", {
          variant: "error",
          autoHideDuration: 3000,
          action: SnackbarConfig,
        });
      }
      dispatch({
        type: OPERATOR_FILE_UPLOAD_FAILURE,
        payload: { isLoading: false },
      });
    }
  };
export const g2OperatorSignupParams = (data) => ({
  type: G2_OPERATOR_SIGNUP_REQUEST,
  payload: data,
});

export const promoteOrDemoteUser =
  (id, roleCode, callback = () => {}) =>
  async (dispatch) => {
    try {
      const promoteDemoteURL =
        apiConfig.promoteToOwner +
        id +
        (roleCode === "OWNER" ? "/demote" : "/promote");
      const promoteDemoteAPIResponse = await putAuthenticationRequest(
        promoteDemoteURL,
        {},
      );
      callback(promoteDemoteAPIResponse);
    } catch (error) {
      callback(error);
    }
  };

export const getGatePinList =
  (params, callback = () => {}) =>
  async (dispatch) => {
    try {
      const response = await getGatePinRequest(`${apiConfig.gatePin}`, params);
      if (response) {
        callback(response?.response?.docs);
      } else {
        enqueueSnackbar("Error fetching Gate pin List", {
          variant: "error",
          autoHideDuration: 3000,
          action: SnackbarConfig,
        });
        callback({});
      }
    } catch (error) {
      enqueueSnackbar("Error fetching Gate pin List", {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      callback({});
    }
  };

export const getGatePinLocationList =
  (customerId, callback = () => {}) =>
  async (dispatch) => {
    try {
      const response = await getGatePinLocationRequest(
        `${apiConfig.gatePinLocations}`,
      );
      if (response) {
        callback(response);
      } else {
        enqueueSnackbar("Error fetching Gate Location List", {
          variant: "error",
          autoHideDuration: 3000,
          action: SnackbarConfig,
        });
        callback({});
      }
    } catch (error) {
      enqueueSnackbar("Error fetching Gate Location List", {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      callback({});
    }
  };
